// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import myw from 'myWorld-base';
import pageHtml from 'text!html/phone/phone.html';
import 'myWorld/layouts/phone/phoneLayoutDetails';

const editPageHtml = $(pageHtml)
    .filter('#edit-page-template')
    .html();

myw.PhoneLayoutFeatureEditor = Backbone.View.extend({
    innerTemplate: _.template(editPageHtml),
    events: {
        'click .mapObjectLabel': 'geomMode'
    },

    /*
     * @class   Page view to display a feature editor
     *
     * @param  {PhoneLayout}  owner       Owner of self
     * @extends {Backbone.View}
     * @constructs
     */
    initialize(options) {
        this.owner = options.owner;
        this.render();
    },

    render() {
        this.setElement(this.innerTemplate());
    },

    /*
     * Activates the Editor's digitizing mode by hiding the fields,
     * so that the user can use the map to set a geometry
     */
    geomMode() {
        this.owner.showPage('page-map');
        this.openSetMapObjectPage();
    },

    /*
     * Opens the geom mode page (map and an instruction bar) that instructs the user to define a geometry on the map
     */
    openSetMapObjectPage() {
        if (!this.geomModePage) {
            this.geomModePage = new GeomModePage({ owner: this.owner });
        }
        this.geomModePage.render();
    }
});

const geomModePageHtml = $(pageHtml)
    .filter('#geom-mode-page-template')
    .html();

const GeomModePage = Backbone.View.extend({
    innerTemplate: _.template(geomModePageHtml),
    events: {
        'click .button-done': 'hide',
        'click .close-btn': 'hide'
    },

    /*
     * @class   A page with the map and and an instruction bar
     *          The map is in geom mode so the user can create/edit a feature geometry
     *
     * @param  {PhoneLayout}  owner   Owner of self
     * @extends {Backbone.View}
     * @constructs
     */
    initialize(options) {
        this.owner = options.owner;
    },

    render() {
        const message = this.owner.detailsPage.editor.getGeomModeMsg();

        this.setElement(
            this.innerTemplate({
                title: this.owner.app.currentFeature.getTitle(),
                message: message
            })
        );
        this.owner.translate(this.$el);

        this.$el.appendTo(this.owner.$('#page-map')).show();
    },

    /*
     * Closes this page and displays the editor again
     */
    hide() {
        this.$el.remove();
        this.owner.showPage('page-edit');
    }
});

export default myw.PhoneLayoutFeatureEditor;
